export const UPDATE = "surveyBlocks/UPDATE";
export const APPEND = "surveyBlocks/APPEND";
export const UPDATE_ONE = "surveyBlocks/UPDATE_ONE";
export const DESTROY = "surveyBlocks/DESTROY";
export const LOADING = "surveyBlocks/LOADING";
